import Axios from "axios";
import { GET_ERRORS } from "./types";
import { success, error } from "./modalsFunctios";
import moment from "moment";
import { exportDocument } from "../../helpers/Utils";
import { antdAsyncMessageError, antdAsyncMessageLoading, antdAsyncMessageSuccess } from "../../helpers/AsyncMessage";
const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;

export const manifestDownloadStackedLabels = async (id, carrier) => {
  try {
    await exportDocument(
      `/api/v1/manifests/${id}/download_stacked_labels?courier=${carrier.toLowerCase()}`,
      `${id}_label_a4.pdf`,
      "POST"
    );
  } catch (err) {
    console.log(err);
  }
};

export const manifestDownloadStackedLabelsA5 = async (id, carrier) => {
  try {
    await exportDocument(
      `/api/v1/manifests/${id}/download_stacked_labels?courier=${carrier.toLowerCase()}&page_size=A5`,
      `${id}_label_a5.pdf`,
      "POST"
    );
  } catch (err) {
    console.log(err);
  }
};

export const manifestLabelsDownload = async (id) => {
  try {
    await exportDocument(
      `/api/v1/manifests/${id}/download_labels`,
      `${id}_label_a6.pdf`,
      "POST"
    );
  } catch (err) {
    console.log(err);
  }
};


export const manifestDownload = async (id) => {
  try {
    await exportDocument(
      `/api/v1/manifests/${id}/download`,
      `${id}_manifest.pdf`,
      "POST"
    );
  } catch (err) {
    console.log(err);
  }
};



export const getSingleManifest = async (id) => {
  try {
    const { data } = await Axios.get(`/api/v1/manifests/${id}`);
    return { success: true, data: data.manifest };
  } catch (err) {
    return { success: false };
  }
};

export const getManifests = (type, page, pageCount, filter) => (dispatch) => {
  dispatch(setManifestLoading());
  Axios.get(
    `/api/v1/manifests/c/${type}.json?page=${page}&per_page=${pageCount}${filter}`
  )
    .then((res) => {
      dispatch({
        type: "GET_MANIFEST",
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const callCourrierManifest = (id, props) => (dispatch) => {
  let params = {
    call_time_from: null,
    call_time_to: null,
  };
  if (props.call_action) {
    params.call_time_from = props.call_time_from;
    params.call_time_to = `${moment(props.call_time_from).format(
      "YYYY-MM-DD"
    )} ${moment(props.call_time_to).format("HH:ss")}`;
  }
  return Axios.post(`/api/v1/manifests/${id}/pickup`, params)
    .then((res) => {
      if (res.data) {
        if (res.data.called_at == null || res.data.api_errors) {
          error("manifest-e");
          dispatch({
            type: "MANIFEST_UPDATE",
            payload: res.data,
          });
          return { success: false, data: res.data };
        } else {
          success("manifest-s");
          dispatch({
            type: "MANIFEST_UPDATE",
            payload: res.data,
          });
          return { success: true };
        }
      }
    })
    .catch((err) => {
      error("manifest-e");
      console.log("Error: ", err);
      // dispatch({
      //   type: GET_ERRORS,
      //   payload: err.response.data,
      // });
      return { success: false };
    });
};

export const close_manifest = (manifest_id) => async (dispatch) => {
  const key = 'close_manifest'
  try {
    antdAsyncMessageLoading({ key })
    const { data } = await Axios.put(
      `/api/v1/manifests/${manifest_id}/close_manifest`
    );
    antdAsyncMessageSuccess({ key })
    dispatch({
      type: "MANIFEST_UPDATE",
      payload: data,
    });
    return { success: true };
  } catch (err) {
    antdAsyncMessageError({ key })
    console.log("Error: ", err);
    return { success: false };
  }
};
export const setManifestLoading = () => {
  return {
    type: "LOADING_MANIFEST",
  };
};
